import React, { Component, Suspense } from 'react';
import { Card, CardBody, Row } from 'reactstrap';
import ContentWrapper from '../../template/Layout/ContentWrapper';
// import StandardReports from '../Components/Reports/StandardReports';
import { connect } from 'react-redux';
import { Tab, Icon } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

const StandardReports = React.lazy(() => import('./StandardReports'));
const MyReports = React.lazy(() => import('./MyReports/List'));
const SharedReports = React.lazy(() => import('./SharedReports'));

class Reportes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 0
    }
  }

  componentDidMount = () => {

  }

  onChangeTab = (e, val) => {
    let { currentTab } = this.state;
    if (currentTab != val.activeIndex) {
      currentTab = val.activeIndex;
      document.getElementById("regresar-div").innerHTML = "";
    }
    this.setState({ currentTab });

  }


  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    return (
      <ContentWrapper>
        <div className="content-heading">
          <span className="icon-my-reports icon-header" />
          {this.props.t("my_reports")}
          <div className="euro-return-tittle">
            <div id="regresar-div" ></div>
          </div>
        </div>
        <Card className="myCard">
          <CardBody>
            <Tab
              menu={{ secondary: true, pointing: true, className: 'custom-tab-menu' }}
              onTabChange={this.onChangeTab}
              panes={[{
                menuItem: this.props.t("standard_reports"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    {' '}
                    <StandardReports type="Standard" user={this.props._user} />
                  </Suspense>
                ),
              },
              {
                menuItem: this.props.t("my_reports"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    {' '}
                    <MyReports type="MyReports" user={this.props._user} />
                  </Suspense>
                ),
              },
              {
                menuItem: this.props.t("shared_reports"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    {' '}
                    <SharedReports type="SharedReports" user={this.props._user} />
                  </Suspense>
                ),
              },]}
            />
          </CardBody>
        </Card>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(withRouter(Reportes)));